export const REQUEST_STATUS_SELECT_DROPDOWN_MAX_HEIGHT = 352
